import './App.css';
import Header from './header/Header';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <div className='full-height'>
        <h1 className='index-text'>Welcome</h1>
        <h2 className='index-text'>Welcome to the PAN Time Registration System</h2>
      </div>
    </div>
  );
}

export default App;
